import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../services/tools/helpers.service';
import { ConstantsService } from '../../../services/constants.service';

@Component({
  selector: 'app-perfil-fondeador',
  templateUrl: './perfil-fondeador.component.html',
  styleUrls: ['./perfil-fondeador.component.scss']
})
export class PerfilFondeadorComponent implements OnInit {

  public isLoading: boolean = false;
  public fondeadorID : number = 0;
  public fondeador : any = {};
  public inversiones_fondeador : any [];
  public isBanco : boolean = false;
  public esTarjeta: boolean = false;
  public esCLABE: boolean = false;
  public hasInversiones: boolean = false;
  public total_inversiones: number = 0;
  public total_intereses: number = 0;
  public total_inversiones_completado: number = 0;
  public total_intereses_completado: number = 0;
  public folios_disponibles:any=[];

  public mes:string = ""; 
  public year:string = "";
  //Login del fondeador
  public isLoginFondeador: boolean = false;

  constructor(
    public location : Location,
    private fondeadoresService: FondeadoresService,
    private activatedRoute : ActivatedRoute,
    private helperService : HelpersService,
    private router : Router,
    private api:ConstantsService
  ) { }

  ngOnInit() {
    this.fondeadorID = this.activatedRoute.snapshot.params.idFondeador;
    //Verificamos que no sea un login de Fondeador
    var userFondeador= localStorage.getItem("User_fondeador");
    if(userFondeador != null){
      var datosTemp = JSON.parse(userFondeador);
      this.isLoginFondeador = datosTemp.isFondeador;
      console.log("LoginF: ", this.isLoginFondeador);
    }

    this.obtFondeadorId(this.fondeadorID);
    this.getInversionesFondeador(this.fondeadorID);
    this.obtFoliosDisponibles(this.fondeadorID);
  }

  public cambiodeMes(event:any){
    //console.log(event);
    var selectElement = event.target;
    var value = selectElement.value.split("-");
    console.log("valor: ", value);
    if (value.length == 1){
      this.mes = ""
      this.year = ""
    }else{
      this.mes = value[0];
      this.year = value[1];
    }
  }

  public num2MesYear(mes:number, year:number){
    var meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    return (meses[mes-1]+" "+year)
  }

  public obtFoliosDisponibles(id:number){
    this.isLoading = true;
    this.fondeadoresService.obtenerFoliosdeFondeador(id).subscribe(
      (response)=>{
        const jsonResult = response.json();
        if(jsonResult.content){
          console.log(jsonResult.content)
          this.folios_disponibles = jsonResult.content;
        }
      },
      (error)=>{
        this.isLoading = false;
        this.helperService.httpGlobalError(error);
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    )
  }

  public obtFondeadorId(id:number){
    this.isLoading = true;
    this.fondeadoresService.getFondeadorById(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.fondeador = jsonResult.content[0];
          console.log("Fondeador ID: ", this.fondeador);
          if(this.fondeador.deposito_fondos === "transferencia"){
            this.isBanco = true;
            if(this.fondeador.tipo_clabe_tarjeta === "tarjeta"){
              this.esTarjeta = true;
            }else if(this.fondeador.tipo_clabe_tarjeta === "clabe"){
              this.esCLABE = true;
            }else{
              this.esTarjeta = false;
              this.esCLABE = false;
            }
          }else{
            this.isBanco = false;
            this.esTarjeta = false;
            this.esCLABE = false;
          }
          this.isLoading = false;
        }

      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public getInversionesFondeador(id){
    this.isLoading = true;
    this.fondeadoresService.getInversionesId(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.inversiones_fondeador = jsonResult.content;

          if(this.inversiones_fondeador.length > 0){
            this.inversiones_fondeador.forEach((inversion, index) => {
              var fechaPago = inversion.fecha_inicio_inversion;
              //Obtenemos el dia del pago
              fechaPago = fechaPago.split(" ")[0].split("-")[2];
              this.inversiones_fondeador[index].fecha_pago = fechaPago;

              //Obtenemos el total invertido
              if (inversion.estatus_completado){
                this.total_inversiones_completado = this.total_inversiones_completado + inversion.capital_ahorrado;
                this.total_intereses_completado = this.total_intereses_completado + inversion.intereses_brutos
              }else{
                this.total_inversiones = this.total_inversiones + inversion.capital_ahorrado;
                this.total_intereses = this.total_intereses + inversion.intereses_brutos

              }
            });
            this.hasInversiones = true;
            console.log("Inversiones: ", this.inversiones_fondeador);
            console.log("Total Inv: ", this.total_inversiones);

          }else{
            this.hasInversiones = false;
          }
          this.isLoading = false;
        }

      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public goDetalleInversion(event:any, id: number){
    // Obtiene el elemento de destino (donde se hizo clic)
    const clickedElement = event.target;
    console.log(clickedElement.tagName);
    if (clickedElement.tagName === 'BUTTON') {
      console.log('Clic en la última celda. No se realizará ninguna acción.');
      // Puedes agregar más lógica aquí si es necesario
    } else {
      console.log('Clic en la fila. Realizar acción deseada.');
      this.router.navigate(['/fondeadores/detalles-inversion/',this.fondeadorID,id]);
    }
  }
  public goEstadoDeCuenta(){
    console.log("Mes seleccionado "+ this.mes);
    if (this.mes == ""){
      if (this.folios_disponibles.length == 0){
        // alert("Usamos Historico");
        window.open(this.api.apiURL+"/profinbox/estadodecuentaclientes?idFondeador="+this.fondeadorID+"&debug=1","__blank")
      }else{
        window.open(this.api.apiURL+"/profinbox/estadodecuentaclientes?idFondeador="+this.fondeadorID,"__blank")
      }
    }else{
      if (this.mes == "historico"){
        window.open(this.api.apiURL+"/profinbox/estadodecuentaclientes?idFondeador="+this.fondeadorID+"&h=true","__blank")
      }else{
        window.open(this.api.apiURL+"/profinbox/estadodecuentaclientes?idFondeador="+this.fondeadorID+"&mes="+this.mes+"&year="+this.year,"__blank")
      }
    }
  }
  public goToComprobante(id){
    event.stopPropagation();
    window.open(this.api.apiURL+"/profinbox/esquemarecibo?idFondeador="+this.fondeadorID+"&idEsquema="+id,"__blank")
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/perfil-fondeador/perfil-fondeador.component.ts